import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=681c6ba6&"
import script from "./EditModule.vue?vue&type=script&lang=ts&"
export * from "./EditModule.vue?vue&type=script&lang=ts&"
import style0 from "./EditModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditModule.vue"
export default component.exports